import { Box, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { FilterModal } from "../../commons/filters/FilterModal.js";
import { Filters } from "../../main-routes/documents/PurchaseOrders.js";
import { PurchaseOrderStatusSelect } from "./filters/PurchaseOrderStatus.js";

export function PurchaseOrdersFilterModal<F extends Filters>({
  handleClose,
  filters,
  setFilters,
  resetFilters,
}: {
  handleClose: () => void;
  filters: F;
  setFilters: React.Dispatch<React.SetStateAction<F>>;
  resetFilters: () => void;
}) {
  const { t } = useTranslate(["PurchaseOrders", "Global"]);

  const [filtersState, setFiltersState] = React.useState(filters);

  return (
    <FilterModal
      title={t("Purchase Orders Filters", {
        ns: "PurchaseOrders",
      })}
      handleApply={() => {
        setFilters(filtersState);
      }}
      handleClose={handleClose}
      handleReset={() => resetFilters()}
      spacing={2}
    >
      <Stack direction="column" spacing={1}>
        <Box>
          <PurchaseOrderStatusSelect
            value={filtersState.filterStatus ?? []}
            setValue={newValue =>
              setFiltersState(state => ({
                ...state,
                filterStatus: newValue,
              }))
            }
          />
        </Box>
      </Stack>
    </FilterModal>
  );
}
